<template>
    <div>
        <div class="tabs is-boxed">
            <ul>
                <li v-for="tab in tabs" :key="tab.name" :class="{ 'is-active': tab.isActive }">
                    <a :href="tab.href" @click="selectTab(tab)"><span v-html="tab.name"></span></a>
                </li>
            </ul>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default{
        data() {
            return { tabs: [{}] };
        },
        created() {
            this.tabs = this.$children;
        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach((tab) => {
                    const x = tab;
                    x.isActive = (x.name === selectedTab.name);
                });
            },
        },
    };
</script>

<style>

    tabs-details {
        width: 100%;
        height: 100%;
    }

    .tabs {
        font-size: 1.3rem;
    }
</style>